import React from 'react';

const Tool04Panel = ({ toolProps, onUpdate }) => {
  const { imageWidth, imageHeight, squareSize, initialCircleSize, brightnessThreshold, circleBrightnessOffset } = toolProps;

  const handleChange = (key, value) => {
    onUpdate({ [key]: value });  // 更新单个属性
  };

  return (
    <div className="panel">
      <h2>B&W Halftone</h2>
      <div className="panel-controls">
        {/* 图像宽度控制 */}
        <div className="control-group">
          <label>Image Width:</label>
          <div className="slider-group">
            <input
              type="range"
              min="100"
              max="1000"
              value={imageWidth}
              onChange={(e) => handleChange('imageWidth', Number(e.target.value))}
            />
            <span>{imageWidth}</span>
          </div>
        </div>

        {/* 图像高度控制 */}
        <div className="control-group">
          <label>Image Height:</label>
          <div className="slider-group">
            <input
              type="range"
              min="100"
              max="1000"
              value={imageHeight}
              onChange={(e) => handleChange('imageHeight', Number(e.target.value))}
            />
            <span>{imageHeight}</span>
          </div>
        </div>

        {/* 正方形大小控制 */}
        <div className="control-group">
          <label>Square Size:</label>
          <div className="slider-group">
            <input
              type="range"
              min="5"
              max="50"
              value={squareSize}
              onChange={(e) => handleChange('squareSize', Number(e.target.value))}
            />
            <span>{squareSize}</span>
          </div>
        </div>

        {/* 圆形初始大小控制 */}
        <div className="control-group">
          <label>Initial Circle Size:</label>
          <div className="slider-group">
            <input
              type="range"
              min="1"
              max="20"
              value={initialCircleSize}
              onChange={(e) => handleChange('initialCircleSize', Number(e.target.value))}
            />
            <span>{initialCircleSize}</span>
          </div>
        </div>

        {/* 亮度对圆形大小影响阈值 */}
        <div className="control-group">
          <label>Brightness Threshold for Circle Size:</label>
          <div className="slider-group">
            <input
              type="range"
              min="0"
              max="255"
              value={brightnessThreshold}
              onChange={(e) => handleChange('brightnessThreshold', Number(e.target.value))}
            />
            <span>{brightnessThreshold}</span>
          </div>
        </div>

        {/* 圆点明度与正方形填充差距 */}
        <div className="control-group">
          <label>Circle Brightness Offset:</label>
          <div className="slider-group">
            <input
              type="range"
              min="0"
              max="255"
              value={circleBrightnessOffset}
              onChange={(e) => handleChange('circleBrightnessOffset', Number(e.target.value))}
            />
            <span>{circleBrightnessOffset}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tool04Panel;
